export const fmtBytes = (b) => {
  if (b == null) return "—";
  if (b < 1024 ** 2) return `${(b / 1024).toFixed(0)} KB`;
  if (b < 1024 ** 3) return `${(b / 1024 ** 2).toFixed(1)} MB`;
  return `${(b / 1024 ** 3).toFixed(2)} GB`;
};

export const fmtDuration = (s) => {
  if (s == null) return "—";
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = Math.floor(s % 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};

export const timecode = (s, fps = 25) => {
  const t = Math.max(0, s || 0);
  const f = Math.floor((t % 1) * fps);
  return `${fmtDuration(t)}:${String(f).padStart(2, "0")}`;
};

export const fmtRate = (sr) => (sr ? `${(sr / 1000).toFixed(sr % 1000 ? 1 : 0)} kHz` : "—");
export const fmtChannels = (c, layout) => (c ? `${c}ch${layout ? ` · ${layout}` : ""}` : "—");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtSecs = (s) => (s == null ? "—" : s < 60 ? `${s.toFixed(1)} s` : `${(s / 60).toFixed(1)} min`);
export const fmtCost = (c, unit) => (c == null ? "n/a" : `${c.toFixed(c > 0 && c < 0.1 ? 3 : 2)} ${unit || ""}`.trim());
